module.exports = __webpack_public_path__ + "static/media/044.ad2fb9ce.jpg";